import React from 'react';

import { LoadableLazy } from '@confluence/loadable';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

const LazyExperimentPlanSelectionModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExperimentPlanSelectionModal" */ './ExperimentPlanSelectionModal.tsx'
			)
		).ExperimentPlanSelectionModal,
});

export const TrialPlanComparisonModalMountComponent = (): React.JSX.Element => {
	const { edition: currentEdition } = useSessionData();
	return <>{currentEdition === ConfluenceEdition.FREE && <LazyExperimentPlanSelectionModal />}</>;
};
